import React, { Component } from 'react'
import { connect } from 'react-redux'
import compose from 'lodash/fp/compose'
import { Trans } from '@lingui/react'

import errorBoundary, {
  ErrorBoundaryProps,
} from 'client/shared/decorators/error-boundary'
import urlFor from 'shared/tools/url-helper'
import deviceHelper from 'shared/tools/device-helper'

import SVGInline from 'react-svg-inline'
import ShelfIcon from 'client/shared/icons/shelf.svg'
import UploadIcon from 'client/shared/icons/upload.svg'
import AchievementsIcon from 'client/shared/icons/achievements.svg'

import Button from 'client/shared/blocks/button'
import ButtonsRow from 'client/shared/blocks/buttons-row'

import { State as AppState } from 'client/shared/reducers/app-reducer'
import { CurrentUserData } from 'client/shared/types/current-user'

import { buildUser } from 'client/bookmate/reducers/user-reducer'
import { State } from 'shared/types/redux'

type Props = {
  app: AppState
  user: CurrentUserData
} & ErrorBoundaryProps

class UserSectionActionsMenuBox extends Component<Props> {
  render() {
    const { app, user } = this.props

    const uploadPath =
      deviceHelper.isTabletSize(app) || deviceHelper.isMobileSize(app)
        ? urlFor.upload('link', app.storedQuery)
        : urlFor.upload(undefined, app.storedQuery)

    return (
      <ButtonsRow>
        <Button
          kind="secondary"
          type="transparent"
          path={urlFor.shelfNew(app.storedQuery)}
        >
          <SVGInline svg={ShelfIcon} />
          <div>
            <Trans id="shelf.create_new_shelf" />
          </div>
        </Button>
        <Button kind="secondary" type="transparent" path={uploadPath}>
          <SVGInline svg={UploadIcon} />
          <div>
            <Trans id="header.upload_title" />
          </div>
        </Button>
        <Button
          kind="secondary"
          type="transparent"
          path={urlFor.userAchievements(
            user.login,
            new Date().getFullYear(),
            app.storedQuery,
          )}
        >
          <SVGInline svg={AchievementsIcon} />
          <div>
            <Trans id="miscellaneous.my_achievements" />
          </div>
        </Button>
      </ButtonsRow>
    )
  }
}

const wrappers = compose(
  connect((state: State) => ({
    app: state.app,
    user: buildUser(state, state.user.login),
  })),
  errorBoundary,
)

export default wrappers(UserSectionActionsMenuBox)
